export default "people";